/**
 * AppIcons.jsx
 * Created by Stephanie Condrey on 11/28/18.
 */

import AppIconSingleton from './appIconSingleton';
import BaseIcon from '../BaseIcon';


class AppIcon extends BaseIcon {
    constructor(props) {
        super(props);

        this.iconSingleton = AppIconSingleton;
    }
}

export class AppIconGooglePlay extends AppIcon {}
AppIconGooglePlay.defaultProps = {
    iconName: 'rec-icon-app-google-play',
    iconClass: 'rec-icon-app-google-play',
    title: 'Download on the Google Play Store'
};

export class AppIconAppleStore extends AppIcon {}
AppIconAppleStore.defaultProps = {
    iconName: 'rec-icon-app-apple-store',
    iconClass: 'rec-icon-app-apple-store',
    title: 'Download on the App Store'
};

export class AppIconRecGov extends AppIcon {}
AppIconRecGov.defaultProps = {
    iconName: 'rec-icon-app-rec-gov',
    iconClass: 'rec-icon-app-rec-gov',
    alt: 'Recreation.gov App'
};
